<template>
  <button type="button" class="btn btn-light" @click="show = true">Add Various</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Various</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
        </div>
        <div class="modal-body">
          <div class="existing-flight mb-3">
            <label for="">Add Various</label>
            <select class="form-select" v-model="order_tax.tax">
              <option :value="null"></option>
              <option v-for="(product, index) in products" :key="index" :value="product">
                {{ product.name }}
              </option>
            </select>
          </div>
          <div class="flight-data">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="">Quantity</label>
                  <input type="number" class="form-control" v-model="order_tax.qty">
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="">Price</label>
                  <div class="input-group">
                    <span class="input-group-text" id="basic-addon1">$</span>
                    <input type="number" class="form-control" v-model="order_tax.price">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
          <button type="button" class="btn btn-primary" @click="addToOrder()">Add to order</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
export default {
  name: 'VariousModal',
  props: ['form', 'products'],
  data() {
    return {
      show: false,
      order_tax: {
        tax: null,
        qty: null,
        price: null,
      },
    }
  },
  methods: {
    addToOrder() {
      let tax = this.order_tax.tax
      let qty = this.order_tax.qty
      let price = this.order_tax.price

      this.form.order_lines.push({
        type: 'various',
        name: tax.name,
        price: price,
        qty: qty,
      })

      this.show = false;

      this.order_tax.tax = null;
      this.order_tax.qty = null;
      this.order_tax.price = null;
    }
  }
}
</script>

<style>

</style>
